import { SIDEBAR_CLICKED } from "../constants/action-types";

export function sidebarClicked(payload) {
    return { type: SIDEBAR_CLICKED, payload }
};
